<template>
  <v-dialog v-model="openDialog"
            max-width="600">
    <v-card class="pa-4">
      <v-layout column>
        <span class="title mb-3">{{ _.get(strategy, 'title', '') }}</span>

        <v-text-field label="Amount"
                      v-model="amount">
        </v-text-field>

        <v-text-field :label="_.get(strategy, 'paymentLabel', '')"
                      v-model="recordNumber">
        </v-text-field>

        <v-textarea label="Comment" v-model="comment"></v-textarea>

        <v-card-actions>
          <v-spacer />
          <v-btn color="accent"
                 :loading="loadingBtn"
                 @click="attachPaymentInformation()">
            {{ _.get(strategy, 'buttonLabel', '') }}
          </v-btn>
          <v-btn color="accent" flat
                 @click="openDialog = false">
            Cancel
          </v-btn>
        </v-card-actions>
      </v-layout>
    </v-card>
  </v-dialog>
</template>

<script>
import _ from 'lodash';

export default {
  name: 'AttachPaymentDialog',
  props: {
    value: {
      type: Boolean,
    },
    strategy: {
      type: Object,
    },
    loadItem: {
      type: Object,
    },
  },
  data() {
    return {
      loadingBtn: false,
      openDialog: this.value,
      amount: null,
      comment: null,
      recordNumber: null,
    };
  },
  computed: {
    _() {
      return _;
    },
  },
  watch: {
    value() {
      this.openDialog = this.value;
      if (!this.value) {
        this.resetForm();
      }
    },
    openDialog() {
      this.$emit('input', this.openDialog);
    },
  },
  methods: {
    resetForm() {
      this.amount = null;
      this.comment = null;
      this.recordNumber = null;
    },
    async attachPaymentInformation() {
      try {
        const paymentInfo = {
          amount: this.amount,
          comment: this.comment,
          recordNumber: this.recordNumber,
        };

        this.loadingBtn = true;

        await this.strategy.callback({ settlementId: this.loadItem.id, paymentInfo });

        this.$store.dispatch('applications/setSuccessNotification', {
          message: `${this.strategy.paymentLabel} attached`,
          timeout: 7000,
        });

        this.$emit('refresh');
      } catch (error) {
        this.$store.dispatch('applications/setErrorNotification', {
          message: error.message,
        });
      } finally {
        this.loadingBtn = false;
        this.openDialog = false;
      }
    },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Companies/AttachPaymentDialog.vue